import React, { useEffect, useState } from "react";
import imgDelete from "../../../images/delete.svg";
import Cancelapp from "../../../images/Cancelapp.png";
import ChangeOwnership from "../../../images/ChangeOwnership.png";
import ConfirmModal from "../modals/ConfirmModal";
import {
    deleteBulkApps,
    cancelMultipleApp,
    GetAllOrganizationsSingleCall,
    GetOrganizationById,
    changeMultipleOwner,
} from "../../api";
import ReactModal from "react-modal";
import SelectDropDown from "../shared/drop-down/drop-down";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);

const action_types = {
    delete: "DELETE",
    cancel: "CANCEL",
    change_ownership: "CHANGE_OWNERSHIP",
};

export default function BulkActions({
    loggedInUser,
    ids,
    getPreappData,
    clear,
}) {
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);
    const [showMultipleOwnerModal, setShowMultipleOwnerModal] = useState(false);
    const [confirmModalText, setConfirmModalText] = useState("");
    const [actionType, setActionType] = useState();

    const [organization_options, setOrgOptions] = useState([]);
    const [user_options, setUserOptions] = useState([]);
    const [selected_org, setSelectedOrg] = useState(null);
    const [selected_user, setSelectedUser] = useState(null);

    useEffect(() => {
        getOwnerOptions();
    }, []);

    const deleteBulkSelectedApps = (e) => {
        e.preventDefault();
        setConfirmModalOpen(true);
        setConfirmModalText(
            "Are you sure you want to delete these applications? This action cannot be undone.",
        );
        setActionType(action_types.delete);
    };

    const bulkCancelApps = (e) => {
        e.preventDefault();
        let data = {
            bulkDeleteIds: ids,
        };
        setConfirmModalOpen(true);
        setConfirmModalText(
            "Are you sure you want to cancel these applications?",
        );
        setActionType(action_types.cancel);
    };

    const confirmConfirm = () => {
        if (actionType == action_types.delete) {
            deleteApps();
        }

        if (actionType === action_types.cancel) {
            cancelApps();
        }

        if (actionType === action_types.change_ownership) {
            changeOwnership();
        }
    };

    const deleteApps = () => {
        let data = {
            bulkDeleteIds: ids,
        };
        deleteBulkApps(data)
            .then((res) => {
                if (res.status) {
                    successResponse();
                    getPreappData();
                    clear();
                } else {
                    errorResponse();
                    clear();
                }
            })
            .catch((err) => {
                errorResponse();
                clear();
            });
    };

    const cancelApps = () => {
        let data = {
            ids: ids,
        };
        cancelMultipleApp(data)
            .then((res) => {
                if (res.status) {
                    successResponse();
                    getPreappData();
                    clear();
                } else {
                    errorResponse();
                    clear();
                }
            })
            .catch((err) => {
                errorResponse();
                clear();
            });
    };

    const onOwnerChangeClick = (e) => {
        setShowMultipleOwnerModal(true);
    };

    const getOwnerOptions = () => {
        GetAllOrganizationsSingleCall()
            .then((response) => {
                let organization_options = [];
                if (response.organization && response.organization.length > 0) {
                    response.organization.forEach((organization) => {
                        organization_options.push({
                            label: organization.name,
                            value: organization.id,
                        });
                    });
                }
                setOrgOptions(organization_options);
            })
            .catch((error) => {});
    };

    // onchange org
    const handleOwnerOrganizationChange = (selected_org) => {
        setSelectedOrg(selected_org);
        GetOrganizationById(selected_org).then((response) => {
            let user_options = [];
            if (response.users && response.users.length > 0) {
                response.users.forEach((user) => {
                    user_options.push({ label: user.name, value: user.id });
                });
            }
            setUserOptions(user_options);
            setSelectedUser("");
        });
    };

    // onchange / select user/owner
    const handleOwnerChange = (selected_val) => {
        setSelectedUser(selected_val);
    };

    const confirmOwnershipChange = () => {
        // e.preventDefault();
        setShowMultipleOwnerModal(false);
        setConfirmModalOpen(true);
        setConfirmModalText(
            "Are you sure you want to change ownership of these applications?",
        );
        setActionType(action_types.change_ownership);
    };

    const changeOwnership = () => {
        let data = {
            ids: ids,
            change_ownership_user_id: selected_user,
        };
        changeMultipleOwner(data)
            .then((response) => {
                if (response.status) {
                    successResponse();
                    getPreappData();
                    clear();
                } else {
                    clear();
                    errorResponse();
                }
            })
            .catch((error) => {
                errorResponse();
                clear();
            });
    };

    const successResponse = () => {
        MySwal.fire({
            title: <p>{"Success!"}</p>,
            icon: "success",
            toast: true,
            position: "top-end",
            timer: 5000,
            timerProgressBar: true,
            showConfirmButton: false,
            customClass: "custom-alert-popup alert-success",
            showCancelButton: false,
        });
    };

    const errorResponse = () => {
        MySwal.fire({
            title: <p>{"Something went wrong!"}</p>,
            icon: "error",
            toast: true,
            position: "top-end",
            timer: 5000,
            timerProgressBar: true,
            showConfirmButton: false,
            customClass: "custom-alert-popup alert-danger",
            showCancelButton: false,
        });
    };

    return (
        <>
            <ConfirmModal
                showLoader={false}
                show={confirmModalOpen}
                handleClose={(e) => setConfirmModalOpen(false)}
                confirmText={confirmModalText}
                handleConfirm={(e) => confirmConfirm()}
                error_message={""}
            />

            <div className="actions-tab">
                <div className="action-btn">
                    <button
                        type="button"
                        className="delete-button"
                        onClick={deleteBulkSelectedApps}
                        title="Delete Apps"
                    >
                        <img src={imgDelete} />
                    </button>
                    <button
                        type="button"
                        className="delete-button"
                        onClick={bulkCancelApps}
                        title="Cancel Apps"
                    >
                        <img src={Cancelapp} />
                    </button>
                    {loggedInUser && !loggedInUser.is_ems_user && (
                        <button
                            type="button"
                            className="delete-button"
                            onClick={onOwnerChangeClick}
                            title="Change Ownership"
                        >
                            <img src={ChangeOwnership} />
                        </button>
                    )}
                </div>
            </div>

            <ReactModal
                isOpen={showMultipleOwnerModal}
                contentLabel="Minimal Modal Example"
                className="modal-change-owrnship"
            >
                <h4 className="text-center owner-title">Change Ownership</h4>
                <div className="row">
                    <div className="col-md-12 dd-change-ownership">
                        <SelectDropDown
                            isSearchable={true}
                            options={organization_options}
                            name="owner_organization"
                            placeholder="Select organization"
                            value={selected_org}
                            handleChange={(selected) => {
                                handleOwnerOrganizationChange(selected.value);
                            }}
                        />
                        <SelectDropDown
                            isSearchable={true}
                            options={user_options}
                            name="owner_users"
                            placeholder="Select user"
                            value={selected_user}
                            handleChange={(selected) => {
                                handleOwnerChange(selected.value);
                            }}
                        />
                    </div>
                    <div className="col-md-12 owner-button-group">
                        <button
                            className="btn btn-danger close_modal"
                            onClick={() => {
                                setShowMultipleOwnerModal(false);
                                setConfirmModalOpen(false);
                            }}
                        >
                            Close
                        </button>
                        <button
                            className="btn btn-success save_modal"
                            onClick={(e) => confirmOwnershipChange()}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </ReactModal>
        </>
    );
}
